import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var FileUploadIcon = function FileUploadIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "FileUploadIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M7.546 4.498a3.2 3.2 0 0 1 1.11.003c.367.066.712.197 1.016.38.304.185.56.417.755.683.196.265.328.558.394.861s.065.614-.003.917a.725.725 0 0 0 .707.884h.624a1.46 1.46 0 0 1 0 2.918h-.624a.725.725 0 0 0 0 1.45h.624a2.91 2.91 0 0 0 .17-5.814 3.6 3.6 0 0 0-.081-.663 3.7 3.7 0 0 0-.644-1.414 4.1 4.1 0 0 0-1.171-1.062 4.5 4.5 0 0 0-1.507-.567 4.6 4.6 0 0 0-1.622-.004 4.5 4.5 0 0 0-1.51.559 3.95 3.95 0 0 0-1.67 1.938 3.7 3.7 0 0 0-2.03.984A3.47 3.47 0 0 0 1 9.061c0 .947.394 1.85 1.084 2.51a3.73 3.73 0 0 0 2.577 1.023.725.725 0 0 0 0-1.45 2.28 2.28 0 0 1-1.575-.622 2.02 2.02 0 0 1-.636-1.461c0-.542.225-1.069.636-1.462a2.28 2.28 0 0 1 1.575-.622c.34 0 .633-.235.707-.566.137-.61.543-1.17 1.16-1.538.306-.182.651-.31 1.018-.375m.19 3.582a.723.723 0 0 1 1.018-.008l.009.01 1.87 1.87a.725.725 0 1 1-1.024 1.026l-.635-.635v2.93a.725.725 0 0 1-1.45 0v-2.93l-.634.635a.725.725 0 0 1-1.026-1.026z",
      clipRule: "evenodd"
    })
  }));
};

export { FileUploadIcon };
